import { render } from "./Langganan.vue?vue&type=template&id=1124e9a0&scoped=true"
import script from "./Langganan.vue?vue&type=script&lang=js"
export * from "./Langganan.vue?vue&type=script&lang=js"

import "./Langganan.vue?vue&type=style&index=0&id=1124e9a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1124e9a0"]])

export default __exports__